<div id="templateAction_ListContainer" >
  @for (item of listItems; track item; let idx = $index) {
    <div class="list-item" (click)="itemClick(item)"
      [attr.id]="buildOverlayId('item', idx)">
      {{item}}
    </div>
  }
</div>
